import { render } from "./AuthView.vue?vue&type=template&id=78a5fe40"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/AuthView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78a5fe40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78a5fe40', __exports__)) {
    api.reload('78a5fe40', __exports__)
  }
  
  module.hot.accept("./AuthView.vue?vue&type=template&id=78a5fe40", () => {
    api.rerender('78a5fe40', render)
  })

}


export default __exports__